var Vendd = (function (Vendd) {
    'use strict';

    Vendd.CancelOrder = (function (CancelOrder) {

        CancelOrder.Messages = (function (Messages) {

            Messages.CancelOrder = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.CancelOrder.Messages.CancelOrder", data);
            };
            Messages.CancelOrder.className = "Vendd.CancelOrder.Messages.CancelOrder";


            Messages.CancelOrderSuccess = function (orderid) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.CancelOrder.Messages.CancelOrderSuccess", orderid);
            };
            Messages.CancelOrderSuccess.className = "Vendd.CancelOrder.Messages.CancelOrderSuccess";


            Messages.CancelOrderFailure = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.CancelOrder.Messages.CancelOrderFailure", data);
            };
            Messages.CancelOrderFailure.className = "Vendd.CancelOrder.Messages.CancelOrderFailure";

            Messages.CancelOrderError = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.CancelOrder.Messages.CancelOrderError", data);
            };
            Messages.CancelOrderError.className = "Vendd.CancelOrder.Messages.CancelOrderError";

            return Messages;

        })(CancelOrder.Messages || {});

        return CancelOrder;

    })(Vendd.CancelOrder || {});

    return Vendd;

})(Vendd || {});